import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ViewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CONTENT } from './content';



@Component({
  selector: 'app-data-repository-component',
  imports: [
    MatTableModule,
    MatIconModule,
    MatSort,
    MatInputModule,
    MatFormFieldModule
  ],
  templateUrl: './data-repository-component.html',
  styleUrl: './data-repository-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataRepositoryComponent implements AfterViewInit {
  displayedColumns: string[] = [
    'no',
    'document',
    'publisher',
    'category',
    'edition',
    'status',
    'notes',
    'remarks',
    'preview',
  ];
  dataSource = new MatTableDataSource(CONTENT);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
